import { render, staticRenderFns } from "./realtimeCoinlist.vue?vue&type=template&id=0b753c44"
import script from "./realtimeCoinlist.vue?vue&type=script&lang=js"
export * from "./realtimeCoinlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports